import { createActions, createReducer } from "reduxsauce";
import { NotificationManager } from "react-notifications";
import { urls } from "../../api/urls";
import { apiConfig } from "../../api/config";
import { IFolder, createFolder } from "../dataMap/folder";
import { IArticle } from "../dataMap/article";

/**Actions and types definitions **/
export const { Types, Creators } = createActions({
  addFolderRequest: null,
  addFolderSuccess: ["folder"],
  addFolderFailure: ["error"],
  addFolderArticleSuccess: ["article", "folderId"],
  fetchFoldersRequest: null,
  fetchFoldersSuccess: ["folders"],
  fetchFoldersFailure: ["error"],
  deleteFolderSuccess: ["folderId"],
  deleteFolderFailure: ["error"],
  removeArticleFolder: ["folderId", "articleId"],
});

interface IFolderState {
  status: boolean;
  folder: IFolder | null;
  folders: IFolder[];
  loading: boolean;
  error: string;
}

const INITIAL_STATE: IFolderState = {
  status: false,
  folder: null,
  folders: [],
  loading: false,
  error: "",
};

export const request = (state = INITIAL_STATE): IFolderState => {
  return {
    ...state,
    status: true,
  };
};
export const success = (
  state = INITIAL_STATE,
  action: { folder: IFolder }
): IFolderState => {
  return {
    ...state,
    status: false,
    folder: action.folder,
    folders: state.folders.concat([action.folder]),
    error: "",
  };
};
export const failure = (
  state = INITIAL_STATE,
  action: { error: string }
): IFolderState => {
  return {
    ...state,
    status: false,
    folder: null,
    error: action.error,
  };
};

export const addArticleToFolder = (
  state = INITIAL_STATE,
  action: { article: IArticle; folderId: number }
) => {
  const newFolders = state.folders;
  const updatedfolder = newFolders.find(
    (folder) => folder.id === action.folderId
  );
  if (updatedfolder && updatedfolder.articles)
    updatedfolder.articles.push(action.article);
  return {
    ...state,
    folders: newFolders,
  };
};

export const foldersRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    loading: true,
    status: true,
  };
};
export const foldersSuccess = (
  state = INITIAL_STATE,
  action: { folders: IFolder[] }
) => {
  return {
    ...state,
    status: false,
    loading: false,
    folders: action.folders,
    error: "",
  };
};
export const foldersFailure = (
  state = INITIAL_STATE,
  action: { error: string }
) => {
  return {
    ...state,
    status: false,
    loading: false,
    folders: [],
    error: action.error,
  };
};

export const deleteSuccess = (
  state = INITIAL_STATE,
  action: { folderId: number }
) => {
  return {
    ...state,
    folders: state.folders.filter((folder) => folder.id !== action.folderId),
  };
};
export const deleteFailure = (
  state = INITIAL_STATE,
  action: { error: string }
) => {
  return {
    ...state,
    error: action.error,
  };
};

export const removeArticle = (
  state = INITIAL_STATE,
  action: { folderId: number; articleId: number }
): IFolderState => {
  const auxFolders = [...state.folders];
  let folderIndex = auxFolders.findIndex(
    (article) => article.id !== action.articleId
  );
  if (folderIndex !== -1) {
    const articles = auxFolders[folderIndex].articles.filter(
      (article) => article.id !== action.articleId
    );
    auxFolders[folderIndex] = {
      ...auxFolders[folderIndex],
      articles,
    };
  }
  return {
    ...state,
    folders: auxFolders,
  };
};

export const HANDLERS = {
  [Types.ADD_FOLDER_REQUEST]: request,
  [Types.ADD_FOLDER_SUCCESS]: success,
  [Types.ADD_FOLDER_FAILURE]: failure,
  [Types.ADD_FOLDER_ARTICLE_SUCCESS]: addArticleToFolder,
  [Types.FETCH_FOLDERS_REQUEST]: foldersRequest,
  [Types.FETCH_FOLDERS_SUCCESS]: foldersSuccess,
  [Types.FETCH_FOLDERS_FAILURE]: foldersFailure,
  [Types.DELETE_FOLDER_SUCCESS]: deleteSuccess,
  [Types.DELETE_FOLDER_FAILURE]: deleteFailure,
  [Types.REMOVE_ARTICLE_FOLDER]: removeArticle,
};
export default createReducer(INITIAL_STATE, HANDLERS);

/** Custom actions definition */

export const Actions = {
  ...Creators,
  addFolder: (dispatch, params: { name: string }) => {
    dispatch(Creators.addFolderRequest());
    apiConfig
      .post(urls.FOLDERS, params)
      .then((response) => {
        // response.data is the users
        const folder = createFolder(response.data);
        dispatch(Creators.addFolderSuccess(folder));
        NotificationManager.info("Ordner erstellt", "Artikel");
      })
      .catch((error) => {
        // error.message is the error message
        let errMsg = "Http Error!!";
        if (error.response.data.errors) errMsg = error.response.data.errors[0];
        dispatch(Creators.addFolderFailure(errMsg));
      });
  },

  fetchFolders: (dispatch, order: string) => {
    dispatch(Creators.fetchFoldersRequest());
    apiConfig
      .get(`${urls.FOLDERS}?ordering=${order}`)
      .then(async (response) => {
        const folders = response.data.map((folder) => createFolder(folder));
        dispatch(Creators.fetchFoldersSuccess(folders));
      })
      .catch((error) => {
        dispatch(Creators.fetchFoldersFailure(error.message));
      });
  },

  deleteFolder: (dispatch, folderId: number) => {
    apiConfig
      .delete(`${urls.FOLDERS}${folderId}`)
      .then(() => {
        dispatch(Creators.deleteFolderSuccess(folderId));
        NotificationManager.info(`Ordner gelöscht`, "Artikel Manager");
      })
      .catch(() => {
        NotificationManager.error(
          `Der Ordner kann nicht gelöscht werden`,
          "Artikel Manager"
        );
      });
  },

  addFolderArticle: (dispatch, article: IArticle, folderId: number) => {
    apiConfig
      .put(`${urls.FOLDERS}${folderId}/articles/${article.id}/`, {})
      .then(async () => {
        dispatch(Creators.addFolderArticleSuccess(article, folderId));
        //NotificationManager.success("Article Moved", "Articles");
      })
      .catch((error) => {
        //NotificationManager.error("The Article can not be moved", "Articles");
      });
  },
};
